import { render } from "./GroupEditModal.vue?vue&type=template&id=0b1dd407&scoped=true"
import script from "./GroupEditModal.vue?vue&type=script&lang=js"
export * from "./GroupEditModal.vue?vue&type=script&lang=js"

import "./GroupEditModal.vue?vue&type=style&index=0&id=0b1dd407&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b1dd407"]])

export default __exports__